import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Accordion, Table, Loader, Icon} from 'semantic-ui-react';
import moment from 'moment';
import _ from 'lodash';
import {dateFormatReservation} from '../../../../../common/constants/datesFormat';
import {Actions} from '../../../../../common/actions';
import OnOrdersModal from '../modals/onOrders';

class OnOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'activeIndex': 0,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    const {code} = this.props;
    this.props.fetchOnOrdersDetail(code);
  }

  componentDidUpdate(prevProps) {
    const {code} = this.props;
    if (code !== prevProps.code) {
      this.props.fetchOnOrdersDetail(code);
    }
  }

  handleClick = (e, titleProps) => {
    const {activeIndex} = this.state;
    const {index} = titleProps;
    const newIndex = activeIndex === index ? -1 : index;
    this.setState({'activeIndex': newIndex});
  };

  renderItems(list) {
    if (!list.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={3}>
            No hay datos disponibles
          </Table.Cell>
        </Table.Row>
      );
    }
    return list.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='left'>
            <OnOrdersModal code={this.props.code} invoice={element.invoice} />
          </Table.Cell>
          <Table.Cell textAlign='right'>{element.quantity}</Table.Cell>
          <Table.Cell textAlign='center'>
            {element.date ?
              moment(element.date).format(dateFormatReservation) :
              ''}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  renderData(list) {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderItems(list);
  }

  render() {
    const {activeIndex} = this.state;
    const {onOrdersDetail} = this.props;
    const data =
      onOrdersDetail && onOrdersDetail.confirmed ?
        onOrdersDetail.confirmed :
        [];

    return (
      <Accordion fluid>
        <Accordion.Title
          active={activeIndex === 0}
          index={0}
          onClick={this.handleClick}
        >
          <Table striped className='toyota-grid'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign='left' colSpan={2}>
                  En Tránsito (facturas confirmadas)
                  <span className='quantity-container'>
                    {_.sumBy(data, 'quantity')}
                  </span>
                </Table.HeaderCell>
                <Table.HeaderCell colSpan={1} textAlign='right'>
                  <Icon name='dropdown' />
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
          </Table>
        </Accordion.Title>

        <Accordion.Content active={activeIndex === 0}>
          <Table striped className='toyota-grid'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign='center'>Factura</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Cantidad</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Fecha de Entrega al Concesionario
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>{this.renderData(data)}</Table.Body>
          </Table>
        </Accordion.Content>
      </Accordion>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.partModals.loadingOnOrdersDetail,
    'onOrdersDetail': state.partModals.onOrdersDetail,
  };
};

const {
  fetchOnOrdersDetail,
} = Actions;

export default connect(mapStateToProps, {
  fetchOnOrdersDetail,
})(OnOrders);
